import React from 'react';
import { useSidebar } from '../../contexts/SidebarContext';
import logoFormasaas from '../../../image/logo-formasaas.png';

export const Logo: React.FC = () => {
  const { isCollapsed } = useSidebar();

  return (
    <div className="flex items-center justify-start">
      <img
        src={logoFormasaas}
        alt="FormaSaas"
        className={`transition-all duration-300 ${
          isCollapsed ? 'h-10 w-10 object-contain' : 'h-14 max-w-[180px]'
        }`}
      />
    </div>
  );
};